(function () {
  function pixelName(eventName) {
    if (eventName === "rhh_pdc_card_click") return "pdc_card_click";
    if (eventName === "rhh_pdc_choose_size_click") return "pdc_choose_size_click";
    return eventName;
  }

  function pushPdcEvent(eventName, detail) {
    var payload = Object.assign(
      {
        event: eventName,
        page_path: window.location.pathname,
        page_type: "product_card",
      },
      detail || {}
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      if (typeof window.__rhhFpPublish === "function") {
        window.__rhhFpPublish(pixelName(eventName), payload);
      } else if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === "function") {
        Shopify.analytics.publish(pixelName(eventName), payload);
      }
    } catch (e) {}
  }

  function getProductContext(card) {
    if (!card) return null;

    const handleTarget =
      card.matches && card.matches('[data-product-handle]')
        ? card
        : card.querySelector('[data-product-handle]');
    const titleEl = card.querySelector('.m-product-card__name, .m-product-card__title a');
    const isFranklin = !!(card.closest && card.closest('.rhh-ai-product-cards, .rhh-ai-article-widget'));

    return {
      product_id: card.dataset.productId || '',
      product_handle: handleTarget
        ? handleTarget.dataset.productHandle || handleTarget.getAttribute('data-product-handle') || ''
        : card.dataset.productHandle || '',
      product_title: titleEl ? titleEl.textContent.trim() : '',
      source: isFranklin ? 'franklin_ai' : 'product_card',
    };
  }

  function onCardAreaClick(event) {
    // Franklin AI cards emit franklin_product_card_* from the widget — skip double-count.
    if (event.target.closest('.rhh-ai-product-cards, .rhh-ai-article-widget')) return;

    const cardLink = event.target.closest(
      '.m-product-card .m-product-card__link, .m-product-card .m-product-card__title a, .m-product-card .m-product-card__name'
    );
    if (!cardLink) return;

    const context = getProductContext(cardLink.closest('.m-product-card'));
    if (!context) return;

    pushPdcEvent('rhh_pdc_card_click', context);
  }

  function onChooseSizeClick(event) {
    if (event.target.closest('.rhh-ai-product-cards, .rhh-ai-article-widget')) return;

    const button = event.target.closest('.m-product-card .m-product-quickview-button');
    if (!button) return;

    const card = button.closest('.m-product-card');
    const context = getProductContext(card) || {};

    pushPdcEvent('rhh_pdc_choose_size_click', {
      product_id: context.product_id || button.dataset.productId || '',
      product_handle: button.dataset.productHandle || context.product_handle || '',
      product_title: context.product_title || '',
      source: context.source || 'product_card',
    });
  }

  // Capture phase so the push runs before link navigation unloads the page.
  document.addEventListener('click', onCardAreaClick, true);
  document.addEventListener('click', onChooseSizeClick, true);
})();
